// TODO: refactor and optimize this class!
class InstallmentForm {
	constructor(el, opts) {
		if (!el) {
			console.error('FilterForm class constructor requires "el" argument!');
			return;
		}

		const submitHandler = _.debounce(opts.submitHandler, 700);

		let $filterForm = $(el);

		this.flatsFrom = 0;
		this.flatsTo = flatsPerPage;
		this.$filterForm = $filterForm;
		this.calculatedPayment();


		if (!$filterForm.length) {
			console.error('FilterForm constructor can\'t find given "el" in DOM!');
			return;
		}

		let $inputs = $($filterForm.get(0).elements);

		$inputs.on("change", event => {
			event.preventDefault();
			this.flatsFrom = 0;
			this.flatsTo = flatsPerPage;
			$inputs.blur();
			$filterForm.trigger("submit");
		});

		$filterForm.on("submit", (event) => {
			event.preventDefault();
			this.calculatedPayment();
			submitHandler($filterForm);
			return false;
		});

		this.$inputs = $inputs;
		$filterForm.trigger("submit");
	}

	resetFilterForm() {
		this.$filterForm[0].reset();
		{
			let value = sliderFirstPayment.sliderRange.options.start;
			sliderFirstPayment.sliderRange.set(value);
		}
		{
			let value = sliderPrice.sliderRange.options.start;
			sliderPrice.sliderRange.set(value);
		}
		{
			let value = sliderYears.sliderRange.options.start;
			sliderYears.sliderRange.set(value);
		}

	}
	calculatedPayment() {
		let $payment             = $('[data-payment-value]');
		let currentFiltersParams = prepareFilterFormValues(this.$filterForm.serializeObject());
		let creditSumm           = currentFiltersParams.price - currentFiltersParams.firstPayment;
		let month                = currentFiltersParams.month;
		let paymentMonth         = Math.round(creditSumm / month).toLocaleString('ru-RU');

		$payment.find('samp').html(paymentMonth);
	}

}
